import React from "react";
import styled from "styled-components";
import Theme from "../../Theme/Theme";
import { IsMobile } from "../../Context/Responsive/Responsive";

function AccountInfoComponent() {
  const isMobile = IsMobile();

  return (
    <Container mobile={isMobile}>
      <RightSide>
        <List>
          <ListItem>
            <Label>نام و نام خانوادگی:</Label>
            <LabelInfo>سالار اشرفی</LabelInfo>
          </ListItem>
          <ListItem>
            <Label>شماره دانشجویی:</Label>
            <LabelInfo>98161105</LabelInfo>
          </ListItem>
          <ListItem>
            <Label>مقطع تحصیلی:</Label>
            <LabelInfo>کارشناسی ارشد</LabelInfo>
          </ListItem>
          <ListItem>
            <Label>رشته تحصیلی:</Label>
            <LabelInfo>فناوری اطلاعات</LabelInfo>
          </ListItem>
          <ListItem>
            <Label>گروه آموزشی:</Label>
            <LabelInfo>مهندسی کامپیوتر</LabelInfo>
          </ListItem>
          <ListItem>
            <Label>مدیر گروه:</Label>
            <LabelInfo>دکتر باقر رحیم پور کامی</LabelInfo>
          </ListItem>
        </List>
      </RightSide>
      <LeftSide>
        <ImgContainer>
          <ImgProfile src={"/Assets/Images/imgExample.png"}></ImgProfile>
        </ImgContainer>
      </LeftSide>
    </Container>
  );
}

export default AccountInfoComponent;

const Container = styled.div`
  width: 83.3%;
  min-width: ${(porps) => (porps.mobile ? "100%" : "1012px")};
  height: ${(porps) => (porps.mobile ? "400px" : "172px")};
  background-color: ${Theme.colorBackgroundBox};
  display: inline-flex;
  justify-content: space-between;
  border-radius: ${Theme.borderRadius};
  margin: 0;
`;

const RightSide = styled.div`
  width: 75%;
  height: 100%;
  box-sizing: border-box;
`;

const List = styled.ul`
  margin: 0;
  width: 75%;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
`;

const ListItem = styled.li`
  list-style-type: none;
  margin-left: 10%;
`;
const Label = styled.p`
  display: inline-block;
  color: ${Theme.colorFontLabel};
  font-size: ${Theme.fontInfoSize};
  font-weight: ${Theme.fontWeight};
  font-style: normal;
`;

const LabelInfo = styled.p`
  display: inline-block;
  margin: 1rem 1.5rem;
  color: ${Theme.colorFontBlack};
  font-size: ${Theme.fontInfoSize};
  font-weight: ${Theme.fontInfoWeight};
  font-style: normal;
`;

const LeftSide = styled.div`
  width: 15%;
  height: 100%;
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  padding: 10px;
`;

const ImgContainer = styled.div`
  min-width: 90px;
  min-height: 90px;
  border-radius: 32px;
  padding: 5px;
  background-color: transparent;
  border: 1px solid ${Theme.colorNotSelected};
  display: flex;
  justify-content: center;
  align-items: center;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  scale: 1.3;
  position: relative;
  &::after {
    position: absolute;
    content: "";
    margin-top: 10px;
    width: 28px;
    height: 2px;
    background-color: ${Theme.colorBluePrimary};
    border-radius: ${Theme.borderRadius};
    bottom: 0;
  }
`;

const ImgProfile = styled.img`
  min-width: 82px;
  min-height: 82px;
  border-radius: 32px;
  object-fit: contain;
`;
